var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError504(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 609,
    height: 277,
    viewBox: "0 0 609 277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.j{fill:#e0e2ee;}.b,.k{fill:none;}.c{clip-path:url(#a);}.d{fill:#f1f2f7;}.e{clip-path:url(#b);}.f{clip-path:url(#c);}.g{clip-path:url(#d);}.h{clip-path:url(#e);}.i{fill:#e1e3ef;}.j,.k{stroke:#d2d8df;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2.921px;}.l{fill:url(#f);}.m{fill:#fff;}.n{fill:#edf0fc;font-size:227px;font-family:Montserrat-Medium, Montserrat;font-weight:500;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M55.852,22.872H26.9a6.861,6.861,0,0,0,0,13.722H45.952A6.855,6.855,0,0,1,50.78,48.3a6.794,6.794,0,0,1-4.828,2.018H6.839a6.861,6.861,0,0,0,0,13.722H24.6a105.191,105.191,0,0,0-8.333,41.17,106.726,106.726,0,0,0,1.144,15.6q.471,3.191,1.136,6.322c12.9-1.98,26.59-3.573,40.879-4.735l1.075.984,1.012-1.148c17.167-1.34,35.185-2.054,53.769-2.054,39.484,0,76.432,3.22,108.023,8.819a105.448,105.448,0,0,0,2.427-16.316q.266-3.705.264-7.474C226,47.1,179.053,0,121.136,0A104.2,104.2,0,0,0,55.852,22.872Z",
    transform: "translate(0 0.282)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.927,0a7,7,0,0,0,0,14h4.145a7,7,0,0,0,0-14Z",
    transform: "translate(0 0.282)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M42.957,2.041,41.944,3.182,40.869,2.2C26.584,3.359,12.9,4.94,0,6.909A104.808,104.808,0,0,0,102.56,89.668a104.581,104.581,0,0,0,62.909-20.909h18.657a6.818,6.818,0,0,0,0-13.636h-8.114a6.818,6.818,0,0,1,0-13.636h43.673a6.818,6.818,0,0,0,0-13.637H198.27a103.263,103.263,0,0,0,6.44-19.086C173.126,3.2,136.187,0,96.712,0,78.133,0,60.118.709,42.957,2.041Z",
    transform: "translate(0.408 0.614)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,.144,1.03,1,2,0C1.332.044.663.092,0,.144Z",
    transform: "translate(0 0.282)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,7A7,7,0,1,0,7,0,7.021,7.021,0,0,0,0,7Z",
    transform: "translate(0 0.282)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 1,
    y1: 0.364,
    x2: 0.604,
    y2: 0.909,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ad7bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b2aff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-386 -266)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2128 -2195)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2699 2499.218)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M55.852,22.872H26.9a6.861,6.861,0,0,0,0,13.722H45.952A6.855,6.855,0,0,1,50.78,48.3a6.794,6.794,0,0,1-4.828,2.018H6.839a6.861,6.861,0,0,0,0,13.722H24.6a105.191,105.191,0,0,0-8.333,41.17,106.726,106.726,0,0,0,1.144,15.6q.471,3.191,1.136,6.322c12.9-1.98,26.59-3.573,40.879-4.735l1.075.984,1.012-1.148c17.167-1.34,35.185-2.054,53.769-2.054,39.484,0,76.432,3.22,108.023,8.819a105.448,105.448,0,0,0,2.427-16.316q.266-3.705.264-7.474C226,47.1,179.053,0,121.136,0A104.2,104.2,0,0,0,55.852,22.872Z",
    transform: "translate(0 0.282)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,139H236V0H0Z",
    transform: "translate(-5 -4.718)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2674 2549.218)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.927,0a7,7,0,0,0,0,14h4.145a7,7,0,0,0,0-14Z",
    transform: "translate(0 0.282)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,24H28V0H0Z",
    transform: "translate(-5 -4.718)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2717 2619.218)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M42.957,2.041,41.944,3.182,40.869,2.2C26.584,3.359,12.9,4.94,0,6.909A104.808,104.808,0,0,0,102.56,89.668a104.581,104.581,0,0,0,62.909-20.909h18.657a6.818,6.818,0,0,0,0-13.636h-8.114a6.818,6.818,0,0,1,0-13.636h43.673a6.818,6.818,0,0,0,0-13.637H198.27a103.263,103.263,0,0,0,6.44-19.086C173.126,3.2,136.187,0,96.712,0,78.133,0,60.118.709,42.957,2.041Z",
    transform: "translate(0.408 0.614)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "f"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,99.668H236.521V0H0Z",
    transform: "translate(-4.592 -4.386)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2760 2607.218)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M161.578,21c-15.967-2.888-33.12-5.119-50.985-6.633-18.432-1.562-37.574-2.353-56.9-2.353-7.806,0-15.65.13-23.314.387L55.418,5.488l43.069,6.525,18.7-6.525,4.737,6.525,11.3-8.386L143.775,13.3,160.426,0,164,4.373A110.137,110.137,0,0,1,161.578,21ZM0,14.106l0,0L11.889.332,30.383,12.4c-10.218.34-20.44.914-30.381,1.705Z",
    transform: "translate(0 0.282)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2758 2621.218)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,.144,1.03,1,2,0C1.332.044.663.092,0,.144Z",
    transform: "translate(0 0.282)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "g"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,11H12V0H0Z",
    transform: "translate(-5 -4.718)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2716 2603.218)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,16.668Q.471,19.865,1.134,23c12.9-1.983,26.582-3.578,40.866-4.742L22.109,0Z",
    transform: "translate(0 0.282)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2915 2674.218)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,7A7,7,0,1,0,7,0,7.021,7.021,0,0,0,0,7Z",
    transform: "translate(0 0.282)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "h"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M0,24H24V0H0Z",
    transform: "translate(-5 -4.718)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2708.395 2489.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M0,0V1.363",
    transform: "translate(116.247)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M0,0H1.363",
    transform: "translate(112.159 4.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M0,1.363V0",
    transform: "translate(116.247 6.814)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1.363,0H0",
    transform: "translate(118.291 4.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M0,0V2.044",
    transform: "translate(37.207 57.236)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M0,0H2.044",
    transform: "translate(31.074 63.369)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M0,2.044V0",
    transform: "translate(37.207 66.775)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M2.044,0H0",
    transform: "translate(40.614 63.369)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.633 18.857)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M2.949,0A2.95,2.95,0,1,1,0,2.95",
    transform: "translate(163.295 112.676)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M9.255,3.944A4.651,4.651,0,1,1,3.991,0",
    transform: "translate(170.45 147.509)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,4.992C1.751,4.446,4.435,2.3,5.056,0c.563,2.037,2.925,4.446,5.056,4.628C7.714,5.477,5.42,8,5.056,9.983,4.809,7.962,1.636,5.286,0,4.992",
    transform: "translate(179.741 80.923)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,2.5A4.3,4.3,0,0,0,2.528,0,3.456,3.456,0,0,0,5.056,2.314,4.2,4.2,0,0,0,2.528,4.991,4.021,4.021,0,0,0,0,2.5",
    transform: "translate(0 109.272)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.573,2.287A2.287,2.287,0,1,1,2.287,0,2.287,2.287,0,0,1,4.573,2.287",
    transform: "translate(11.679 14.694)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.644,3.823A3.822,3.822,0,1,1,3.822,0,3.823,3.823,0,0,1,7.644,3.823",
    transform: "translate(143.645 156.767)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.063,3.033A3.031,3.031,0,1,1,3.032,0,3.032,3.032,0,0,1,6.063,3.033",
    transform: "translate(215.824 9.733)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M3.822,1.912A1.911,1.911,0,1,1,1.911,0,1.911,1.911,0,0,1,3.822,1.912Z",
    transform: "translate(55.166 152.484)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M4.573,2.287A2.287,2.287,0,1,1,2.287,0,2.287,2.287,0,0,1,4.573,2.287Z",
    transform: "translate(53.278 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M3.838,5.478A2.831,2.831,0,1,1,5.477,1.825,2.831,2.831,0,0,1,3.838,5.478Z",
    transform: "translate(112.342 170.087)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M0,54.144H13.069L6.223,75.926l30.5-30.805H18.358L28.628,0Z",
    transform: "translate(2802.155 2582.504)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2748.328 2529.702)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M132,39.111a25.9,25.9,0,0,0-11.061-4.5,39.106,39.106,0,0,0-69.66-19.588A25.153,25.153,0,0,0,18.339,35.775a26.072,26.072,0,0,0,7.608,50.971A16.864,16.864,0,0,0,28.2,86.9h85.252A26.069,26.069,0,0,0,132,39.111",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.64,1.911A26.351,26.351,0,0,0,23.727,0C10.621,0,0,9.355,0,20.893a18.448,18.448,0,0,0,.321,3.423C10.511,9.921,17.532,4.2,33.64,1.911",
    transform: "translate(25.892 22.432)"
  }))), /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "translate(386 486)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5")), /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "translate(843 486)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError504);
export default __webpack_public_path__ + "static/media/error504.46b19eabc587d1a4c2bbfeb040de8d96.svg";
export { ForwardRef as ReactComponent };